$('.play_btn').on('click', function () {
    var $box = $(this).closest('.swiper-slide');
    var $video = $box.find('video')[0];

    $box.find('.thumb_img').hide();
    $box.find('.play_btn').hide();
    $box.find('.video_frame').show();

    $('.swiper-slide').not($box).each(function () {
        var $otherVideo = $(this).find('video')[0];
        if ($otherVideo) {
            $otherVideo.pause();
        }
        $(this).find('.thumb_img').show();
        $(this).find('.play_btn').show();
        $(this).find('.video_frame').hide();
    });
    if ($video) {
        $video.play();
    }
});
